export default __webpack_public_path__ + "static/media/CofE-Example.5566abe9.jpg";